import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import {Button} from '@chakra-ui/react';
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';

export function PaymentModal({amount, setCurrency, paymentCurrency, setShowPaymentModal, makePayment, loading, showPaymentAccount}) {
  const {userProfile} = useContext(UserContext);

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px]'>
                <div onClick={() => setShowPaymentModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                <a className='text-dark text-[40px] font-bold'>{paymentCurrency} {amount}</a>
                <div className='w-[70%] flex flex-col'>
                    <button onClick={() => !loading && makePayment('NGN')} className='rounded-[10px] py-3 bg-gray-200 hover:bg-yellow font-semibold text-dark my-2'>Pay {amount * userProfile?.misc?.usd_ngn_exchange} NGN</button>
                    {/* <button onClick={() => !loading && makePayment('USD')} className='rounded-[10px] py-3 bg-gray-200 hover:bg-yellow font-semibold text-dark my-2'>Pay in USD</button>
                    <button onClick={() => !loading && makePayment('EUR')} className='rounded-[10px] py-3 bg-gray-200 hover:bg-yellow font-semibold text-dark my-2'>Pay in EUR</button> */}
                </div>
                {showPaymentAccount && (
                    <div className='w-[70%] flex flex-col items-center justify-center p-4 border-2 rounded-[10px] bg-gray-100'>
                        <p className='text-dark text-[12px] mb-3 text-center'>Pay into the account below</p>
                        <p className='font-semibold text-[15px] text-center'>GT Bank</p>
                        <p className='font-semibold text-[15px] text-center'>0008579695</p>
                        <p className='font-semibold text-[15px] text-center'>Adedamoye Oshomoji</p>
                        <p className='text-dark text-[12px] mt-3 text-center'>Please reach out to us using the chat widget at the bottom right once payment is successful.</p>
                    </div>
                )}
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

